var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgVideo28 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.5 3a.5.5 0 0 0 0 1h14a.5.5 0 0 0 0-1h-14Zm-2 5A1.5 1.5 0 0 0 3 9.5v12A1.5 1.5 0 0 0 4.5 23h18a1.5 1.5 0 0 0 1.5-1.5v-12A1.5 1.5 0 0 0 22.5 8h-18Zm0-1A2.5 2.5 0 0 0 2 9.5v12A2.5 2.5 0 0 0 4.5 24h18a2.5 2.5 0 0 0 2.5-2.5v-12A2.5 2.5 0 0 0 22.5 7h-18Zm6.754 5.065a.5.5 0 0 1 .503.006l5 3a.5.5 0 0 1 0 .858l-5 3A.5.5 0 0 1 11 18.5v-6a.5.5 0 0 1 .254-.435ZM12 17.617l3.528-2.117L12 13.383v4.234Z",
  clipRule: "evenodd"
})));
export { SvgVideo28 as ReactComponent };
export default __webpack_public_path__ + "dea712850a65be17ee7a9051693dd951.svg";